import { Card } from '@deere/ux.uxframe-react'

export const ErrorCard = ({ errors, title }) => {
    window.scrollTo(0,0);
    return (
        <>
        <Card className='p-2 mb-2 bg-danger'>
            <Card.Body className="uxf-card-body-table">
                <Card.Title className='pb-3 text-white'>
                    {title}
                </Card.Title>
                {
                    errors.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </Card.Body>
        </Card>
        </>);
}